import module from 'recursoshumanos/module.js'
import template from './template.html'

export class RecursoshumanosVisorlotesListaItemComponent {
  data
  fecha
  onClose
  editando = false

  eliminar (data) {
    this.editando = false
    if(data) {
      this.onClose()
    }
  }
}

module.component('recursoshumanosVisorlotesListaItem', {
  controller: RecursoshumanosVisorlotesListaItemComponent,
  template,
  bindings: {
    data: '<',
    fecha: '<',
    onEditar: '&',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/visorlotes/lista/item/component.js